module.exports = "<div class=\"flex flex-between search-in-tree-hd\"> <div class=txt>部门搜索</div> <div class=search-in-tree-box> <input class=search-in-tree placeholder=请输入搜索关键字> </div> </div> <ul id=tree1></ul> <div class=\"buttons-in-tree flex\"> <button class=select-all-nodes>全选</button> <button class=reverse-all-nodes>反选</button> <button class=reset>取消</button> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/tree/tree.html
// module id = 2087
// module chunks = 50